// extracted by mini-css-extract-plugin
export default {"Container":"Features_Container__hfDD2","Title":"Features_Title__9++XB","Subtitle":"Features_Subtitle__6Btnu"};